import PictureMixin from "@/mixins/PictureMixin.vue";
import "./EventPicture.sass";

export default {
  name: "EventPicture",
  data: () => ({
    showFullCopyright: false,
    height: 360,
    imageHeight: 253.1,
    imageWidth: 450
  }),
  props: {
    event: {
      type: Object,
      required: true
    },
    useFallbackPicture: {
      type: Boolean,
      default: false
    },
    fallbackPicture: {
      type: Object
    },
    showCopyright: {
      type: Boolean,
      default: false
    },
    showCopyrightInList: {
      type: Boolean,
      default: false
    },
    detailView: {
      type: Boolean,
      default: false
    }
  },
  mixins: [PictureMixin],
  methods: {
    urlIsPictureFallback(url) {
      if (this.showCopyrightInList) {
        url = url.replace(/autocrop\/\d+\/\d+\//, "");
        url = url.replace(/smartcrop\/\d+\/\d+\//, "");
        if (url.includes(this.fallbackPicture.url)) {
          return true;
        }
      }
    },
    setImageHeight() {
      this.height = this.$refs?.eventImage?.clientWidth / (16 / 9);
    }
  },
  mounted() {
    window.addEventListener("resize", this.setImageHeight);
    setInterval(this.setImageHeight, 1000);
  },
  unmounted() {
    window.removeEventListener("resize", this.setImageHeight);
  },
  computed: {
    firstPicture() {
      return (
        this.event &&
        this.event.pictures &&
        this.event.pictures.length &&
        this.event.pictures[0]
      );
    },
    picture() {
      const aspect = "16:9";
      // show main-image if entry uses no channels or picture has web-channel
      const entryHasWebChannel = this.event?.channels?.includes("web");
      const pictureHasWebChannel = this.event?.pictures?.[0]?.channels?.includes(
        "web"
      );
      const pictureForWeb = !entryHasWebChannel || pictureHasWebChannel;

      if (this.firstPicture && pictureForWeb) {
        // right image size?
        if (
          this.event &&
          this.event.pictures[0].image_sizes &&
          this.event &&
          this.event.pictures[0].image_sizes[aspect]
        ) {
          if (this.detailView) {
            this.imageWidth = 1280;
            return this.event.pictures[0].image_sizes[aspect].url.replace(
              /\/focus\//,
              "/mainimage/" + this.imageWidth + "/"
            );
          } else {
            return this.event.pictures[0].image_sizes[aspect].url.replace(
              /\/focus\//,
              "/mainimage/" + this.imageWidth + "/"
            );
          }
        }
        if (this.detailView) {
          this.imageWidth = 1280;
          this.imageHeight = 720;
          return this.event.pictures[0].url.replace(
            /\/events\//,
            "/smartcrop/" +
              this.imageWidth +
              "/" +
              this.imageHeight +
              "/events/"
          );
        } else {
          return this.event.pictures[0].url.replace(
            /\/events\//,
            "/smartcrop/" +
              this.imageWidth +
              "/" +
              this.imageHeight +
              "/events/"
          );
        }
      } else if (this.useFallbackPicture && this.fallbackPicture) {
        // fallback picture

        // right image size?
        if (
          this.fallbackPicture &&
          this.fallbackPicture.image_sizes &&
          this.event &&
          this.fallbackPicture.image_sizes[aspect]
        ) {
          return this.fallbackPicture?.image_sizes?.[aspect]?.url?.replace(
            /\/focus\//,
            "/mainimage/" + this.imageWidth + "/"
          );
        }

        return this.fallbackPicture?.url?.replace(
          /\/events\//,
          "/smartcrop/" + this.imageWidth + "/" + this.imageHeight + "/events/"
        );
      }

      return "";
    },
    primaryColor() {
      return this.$vuetify.theme.currentTheme.primary;
    },
    momentCancelled() {
      if (this.event?.moment && this.event?.moment?.cancelled)
        return this.event.moment.cancelled;
      if (this.event?.cancelled) return this.event.cancelled;
    }
  }
};
